<router-outlet></router-outlet>

<ngx-spinner bdOpacity=0.1 bdColor="rgba(51, 51, 51, 0.8)" size="medium" color="blueviolet" type="ball-square-spin" [fullScreen]="true">
    <p style="color: black"> Loading... </p>
</ngx-spinner>